<div class="app-combobox" ngbDropdown #myDrop="ngbDropdown" (openChange)="toggled($event)">
  <div ngbDropdownToggle>
    <input
      type="text"
      class="js-app-combobox__field app-combobox__field"
      autocomplete="off"
      placeholder="{{ defaultText }}"
      [ngModel]="(initBy && initBy[textKey]) || searchText" [ngModelOptions]="{ standalone: true }" (ngModelChange)="(initBy && initBy[textKey]) || (searchText = $event)"
      (keyup)="searchText = $event.target.value"
      name="{{ name }}"
      id="{{ name }}"
      fieldTrim
      [disabled]="isDisabled"
    />
    <button type="button" class="app-combobox__corner" [disabled]="isDisabled"></button>
  </div>
  <div ngbDropdownMenu *ngIf="(items | comboboxSearchFilter: searchText : textKey).length">
    <button type="button" ngbDropdownItem *ngIf="nullChoice" class="app-combobox__text--placeholder" (click)="onReset(); $event.stopPropagation(); myDrop.close()">
      <i>{{ defaultText }}</i>
    </button>
    <button type="button"
      ngbDropdownItem
      *ngFor="let item of items | comboboxSearchFilter: searchText : textKey"
      (click)="onSelect(item); $event.stopPropagation(); myDrop.close()"
      [innerHTML]="item[textKey] | comboboxSearchHighlight: searchText"
    ></button>
  </div>
</div>
